import { formatMoney } from "utils";
import React, { useState } from "react";
import ReportsView from "../ReportsView";
import { images } from "assets/themes";

const Footer = ({ id, account }) => {
    const [reportLoading, setReportLoading] = useState({ pdf: false, excel: false });
    const [showBanner, setShowBanner] = useState(true);

    return (
        <div className="fixed-bottom w-100 ">
            {showBanner && (
                <div className="w-100 px-2 px-md-3 mb-2">
                    <div className="d-flex align-items-center justify-content-between bg-white shadow-sm border rounded-3 p-2 px-3">
                        <div className="d-flex align-items-center gap-2">
                            <h2 className="fs-5 mb-0">Download App</h2>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <a
                                href="https://play.google.com/store/apps/details?id=com.bahikhata"
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-app d-flex align-items-center gap-1 p-2 btn-lg"
                            >
                                <i className="bi bi-google-play" />
                                Install
                            </a>

                        </div>
                        <button
                            className="btn btn-sm rounded-4 btn-light position-absolute end-0"
                            style={{ top: "-13px", zIndex: "0" }}
                            onClick={() => setShowBanner(false)}
                        >
                            ✕
                        </button>

                    </div>
                </div>
            )}
            <div className="py-2 px-3 d-flex shadow-sm bg-light border-top">
                <h3 className="my-auto text-left text-md-left col-8" title="Account Balance">
                    Balance :
                    {
                        account ?
                            <span className="fs-5">
                                <i>{formatMoney(account.get("balance"))}</i>
                            </span> : ""
                    }
                </h3>
                {account && (
                    <div className="d-flex justify-content-end w-100">
                        <div>
                            <div className="btn btn-sm dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <span className="d-flex align-items-center">
                                    {reportLoading.pdf ?
                                        <span className="spinner-border text-app mt-2" role="status" aria-hidden="true" />
                                        : <i className="bi bi-file-pdf fs-2 text-app" />
                                    }
                                </span>
                            </div>
                            <ReportsView id={id} setReportLoading={setReportLoading} type="pdf" />
                        </div>
                        <div>
                            <div className="btn btn-sm dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <span className="d-flex align-items-center">
                                    {reportLoading.excel ?
                                        <span className="spinner-border text-app mt-2" role="status" aria-hidden="true" />
                                        : <i className="bi bi-filetype-xls fs-2 text-app" />
                                    }
                                </span>
                            </div>
                            <ReportsView id={id} setReportLoading={setReportLoading} type="excel" />
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Footer;